import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { uploadFormConfigSelector } from '../../selectors';
import { CustomFieldsMap, FIELDS } from 'components/forms';
import { reduxForm } from 'redux-form';

export const Toc = reduxForm({
  form: 'uploadTocForm',
})(
  connect(
    (state) => ({
      uploadFormConfig: uploadFormConfigSelector(state),
    }),
    false
  )(({ uploadFormConfig, isValid = false }) => {
    if (!uploadFormConfig) {
      return null;
    }

    const textBoxField = uploadFormConfig.find((field) => field.type === FIELDS.TEXT_BOX);

    if (!textBoxField) {
      return null;
    }

    return (
      <div className={`ct-toc-container${isValid ? '--enabled' : '--disabled'}`}>
        <form className="form-toc">{CustomFieldsMap[textBoxField.type](textBoxField.config, 1)}</form>
      </div>
    );
  })
);

Toc.propTypes = {
  isValid: PropTypes.bool,
};
